import { Popover, Transition } from "@headlessui/react";
import { Cpu, Globe, Menu, PieChart, RotateCcw, ShieldCheck, Target, X } from "lucide-react";
import { Fragment, ReactNode, useEffect, useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import { useActiveTab } from "./ActiveTabContext"; // Import the shared context
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger
} from "./ui/select"; // Assuming you have a custom Select component

const DigitalWealthTabTitle = [
      {
        title : "Secure and Regulated",
        icon: ShieldCheck,
        themeColor: "#57c0af",
        link: "/",
      },
      {
        title : "Tailored Equity Solutions",
        icon: Target,
        themeColor: "orange",
        link: "/",
      },
      {
        title : "Portfolio Rebalancing",
        icon: RotateCcw,
        themeColor: "#45DFB1",
        link: "/",
      },
      {
        title : "Asset Diversification",
        icon: PieChart,
        themeColor: "violet",
        link: "/",
      },
      {
        title : "Robo Advisory",
        icon: Cpu,
        themeColor: "#0dd3ff",
        link: "/",
      },
      {
        title : "Global Market Access Tentative",
        icon: Globe,
        themeColor: "#57c0af",
        link: "/",
      },
     

 ]


 const servicesData = [
    {
      mediaSrc: "/Arranging Custody.gif",
      title: "Arranging Custody",
       link: "/",
      
   
    },
    {
      mediaSrc: "/Arranging Deals in Investments.gif",
      title: "Arranging Deals in Investments",
      link: "/",
     
    },
    {
      mediaSrc: "/Managing assets1.gif",
      title: "Managing Assets",
       link: "/",
     
    },
    {
      mediaSrc: "/Arranging Credit & Advising on Credit.gif",
      title: "Arranging Credit & Advising on Credit",
       link: "/",
    
     
    },
    {
      mediaSrc: "/Legacy Planning & Family Office Management.gif",
      title: "Legacy Planning & Family Office Management",
       link: "/",
      
     
    },
    {
      mediaSrc: "/Advising on financial products 1.gif",
      title: "Advising on Financial Products",
       link: "/",
     
    },
  ]

// NavItem Component
function NavItem({
  href,
  children,
  isActive,
  onClick,
}: {
  href: string;
  children: ReactNode;
  isActive: boolean;
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}) {
  return (
    <li className="px-4">
      <a
        href={href}
        onClick={onClick}
        className={`flex items-center gap-1 px-2 py-2 text-base text-xs ${isActive ? "text-[#57c0af]" : "text-white hover:text-[#57c0af]"
          }`}
      >
        {children}
      </a>
    </li>
  );
}

// Desktop Navigation
function DesktopNavigation() {
  const { activeTab, setActiveTab } = useActiveTab();
  const location = useLocation();
  const [isAdvisoryOpen, setIsAdvisoryOpen] = useState(false);
  const [isPriveOpen, setIsPriveOpen] = useState(false);

  // Don't set active tab on initial page load — only on subsequent navigations
  const _firstNavRender = useRef(true);
  useEffect(() => {
    if (_firstNavRender.current) {
      _firstNavRender.current = false;
      return;
    }
    setActiveTab(location.pathname + location.hash);
  }, [location.pathname, location.hash, setActiveTab]);

  const handleScrollToSection = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    href: string
  ) => {
    event.preventDefault();

    const [path, hash] = href.split("#");
    if (path && window.location.pathname !== path) {
      window.location.href = `${path}#${hash}`;
    } else {
      const target = document.querySelector(`#${hash}`);
      target?.scrollIntoView({ behavior: "smooth" });
    }

    setActiveTab(href);
  };

  return (
    <nav className="hidden md:flex tracking-wide font-poppins z-50">
      <ul className="flex items-center -space-x-4 tracking-wider text-white text-[26px]">
        {/* <NavItem
          href="/"
          isActive={activeTab === "/" || activeTab === "/#"}
          onClick={() => setActiveTab("/")}>
          Home
        </NavItem> */}
         {/* 
        <NavItem
          href="/#advisory"
          isActive={activeTab === "/#advisory"}
          onClick={(e) => handleScrollToSection(e, "/#advisory")}>
          Advisory
        </NavItem> */}

         {/* dropdown for advisory */}
          <li className="px-4 relative" onMouseEnter={() => setIsAdvisoryOpen(true)} onMouseLeave={() => setIsAdvisoryOpen(false)}>
          <Link
            to="/"
            className={`flex items-center gap-1 px-2 py-2 text-base text-xs transition ${
                isAdvisoryOpen ||
                activeTab === "/#advisory" ||
                activeTab.includes("advisory") ||
                (activeTab !== "/" && DigitalWealthTabTitle.some((product) => activeTab === product.link))
                ? "text-[#57c0af]"
                : "text-white hover:text-[#57c0af]"
              } focus:outline-none`}
            // onClick={() => setActiveTab("/")}
            onClick={(e) => handleScrollToSection(e, "/#advisory")}
          >
            Advisory
          </Link>
          <Transition
            show={isAdvisoryOpen}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <div className="absolute left-0 z-50 mt-2 w-64 bg-black/95 backdrop-blur-xl border border-[#57c0af]/30 rounded-2xl shadow-2xl overflow-hidden">
              <div className="p-2">
                {DigitalWealthTabTitle.map((product, index) => {
                  const Icon = product.icon;
                  return (
                    <Link
                      key={index}
                      to={product.link}
                    
                      className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 transition-all duration-200 group/item"
                      onClick={(e) => handleScrollToSection(e, "/#advisory")}
                    >
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center border border-white/10 group-hover/item:border-current transition-colors"
                        style={{ color: product.themeColor }}
                      >
                        <Icon size={16} strokeWidth={1.5} />
                      </div>
                      <span className="text-xs text-white group-hover/item:text-[#57c0af] transition-colors">
                        {product.title}
                      </span>
                    </Link>
                  );
                })}
              </div>
            </div>
          </Transition>
        </li> 

        {/* <NavItem
          href="/#nuqiprive"
          isActive={activeTab === "/#nuqiprive"}
          onClick={(e) => handleScrollToSection(e, "/#nuqiprive")}>
          Prive
        </NavItem> */}

          {/* dropdown for prive */}
          <li className="px-4 relative" onMouseEnter={() => setIsPriveOpen(true)} onMouseLeave={() => setIsPriveOpen(false)}>
          <Link
            to="/digitalwealth"
            className={`flex items-center gap-1 px-2 py-2 text-base text-xs transition ${
                isPriveOpen ||
                activeTab === "/#nuqiprive" ||
                activeTab.includes("prive") ||
                (activeTab !== "/" && servicesData.some((product) => activeTab === product.link))
                ? "text-[#57c0af]"
                : "text-white hover:text-[#57c0af]"
              } focus:outline-none`}
            // onClick={() => setActiveTab("/")}
            onClick={(e) => handleScrollToSection(e, "/#nuqiprive")}
          >
            Prive
          </Link>
          <Transition
            show={isPriveOpen}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <div className="absolute left-0 z-50 mt-2 w-64 bg-black/95 backdrop-blur-xl border border-[#57c0af]/30 rounded-2xl shadow-2xl overflow-hidden">
              <div className="p-2">
                {servicesData.map((product, index) => {
                  return (
                    <Link
                      key={index}
                      to={product.link || "/"}
                      className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 transition-all duration-200 group/item"
                      onClick={(e) => handleScrollToSection(e, "/#nuqiprive")}
                    >
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center border border-white/10 group-hover/item:border-current transition-colors overflow-hidden"
                      >
                        <img src={product.mediaSrc} alt={product.title} className="w-full h-full object-cover" />
                      </div>
                      <span className="text-xs text-white group-hover/item:text-[#57c0af] transition-colors">
                        {product.title}
                      </span>
                    </Link>
                  );
                })}
              </div>
            </div>
          </Transition>
        </li> 



        <NavItem
          href="/iris"
          isActive={activeTab === "/iris"}
          onClick={() => setActiveTab("/iris")}>
          IRIS
        </NavItem>
        <NavItem
          href="/ethosphere"
          isActive={activeTab === "/ethosphere"}
          onClick={() => setActiveTab("/ethosphere")}>
          Ethosphere
        </NavItem>
        <NavItem
          href="/Disclosures"
          isActive={activeTab === "/Disclosures"}
          onClick={() => setActiveTab("/Disclosures")}>
          Disclosures
        </NavItem>
      </ul>
    </nav>
  );
}

// Mobile Navigation
function MobileNavigation() {
const { activeTab, setActiveTab } = useActiveTab();
const [isAdvisoryOpen, setIsAdvisoryOpen] = useState(false);
const [isPriveOpen, setIsPriveOpen] = useState(false);

    useEffect(() => {
    setActiveTab(location.pathname + location.hash);
  }, [location.pathname, location.hash, setActiveTab]);


  // const handleScrollToSection = (
  //   event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  //   targetHash: string
  // ) => {
  //   event.preventDefault();

  //   if (window.location.pathname !== "/") {
  //     window.location.href = `/${targetHash}`;
  //   } else {
  //     const target = document.querySelector(targetHash);
  //     target?.scrollIntoView({ behavior: "smooth" });
  //   }

  //   setActiveTab(`/${targetHash}`);
  // };
const handleScrollToSection = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    href: string
  ) => {
    event.preventDefault();

    const [path, hash] = href.split("#");
    if (path && window.location.pathname !== path) {
      window.location.href = `${path}#${hash}`;
    } else {
      const target = document.querySelector(`#${hash}`);
      target?.scrollIntoView({ behavior: "smooth" });
    }

    setActiveTab(href);
  };
  return (
    <div className="lg:hidden font-poppins">
      <Popover>
        <Popover.Button>z
          <Menu className="h-6 w-6 text-white absolute top-1/4" />
        </Popover.Button>
        <Transition.Root>
          <Transition.Child
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-150 ease-in"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Popover.Overlay className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>
          <Transition.Child
            as={Fragment}
            enter="duration-150 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="duration-150 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Popover.Panel className="absolute top-0 left-0 w-full bg-black p-4">
              <div className="flex justify-between items-center">
                <Popover.Button>
                  <X className="h-6 w-6 text-white" />
                </Popover.Button>
              </div>
              <nav className="mt-4 tracking-wide">
                <ul className="space-y-4 tracking-wide">
                  {/* <NavItem href="/" isActive={false} onClick={() => setActiveTab("/")}>
                    Home
                  </NavItem> */}
                  {/* <NavItem
                    href="/#advisory"
                    isActive={false}
                    onClick={(e) => handleScrollToSection(e, "#advisory")}>
                    Advisory
                  </NavItem> */}
                  {/* dropdown for advisory */}
                     <li className="px-4 relative" onMouseEnter={() => setIsAdvisoryOpen(true)} onMouseLeave={() => setIsAdvisoryOpen(false)}>
          <Link
            to="/"
            className={`flex items-center gap-1 px-2 py-2 text-base text-xs    transition ${isAdvisoryOpen || DigitalWealthTabTitle.some(product => activeTab === product.link)
                ? "text-[#57c0af]"
                : "text-white hover:text-[#57c0af]"
              } focus:outline-none`}
            // onClick={() => setActiveTab("/")}
            onClick={(e) => handleScrollToSection(e, "/#advisory")}
          >
            Advisory
          </Link>
          <Transition
            show={isAdvisoryOpen}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <div className="absolute left-0 z-50 mt-2 w-64 bg-black/95 backdrop-blur-xl border border-[#57c0af]/30 rounded-2xl shadow-2xl overflow-hidden">
              <div className="p-2">
                {DigitalWealthTabTitle.map((product, index) => {
                  const Icon = product.icon;
                  return (
                    <Link
                      key={index}
                      to={product.link}
                    
                      className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 transition-all duration-200 group/item"
                      onClick={(e) => handleScrollToSection(e, "/#advisory")}
                    >
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center border border-white/10 group-hover/item:border-current transition-colors"
                        style={{ color: product.themeColor }}
                      >
                        <Icon size={16} strokeWidth={1.5} />
                      </div>
                      <span className="text-xs text-white group-hover/item:text-[#57c0af] transition-colors">
                        {product.title}
                      </span>
                    </Link>
                  );
                })}
              </div>
            </div>
          </Transition>
        </li> 
                  {/* dropdown for prive */}
                  <li className="px-4 relative" onMouseEnter={() => setIsPriveOpen(true)} onMouseLeave={() => setIsPriveOpen(false)}>
          <Link
            to="/digitalwealth"
            className={`flex items-center gap-1 px-2 py-2 text-base text-xs    transition ${isPriveOpen || servicesData.some(product => activeTab === product.link)
                ? "text-[#57c0af]"
                : "text-white hover:text-[#57c0af]"
              } focus:outline-none`}
            onClick={(e) => handleScrollToSection(e, "/#nuqiprive")}
          >
            Prive
          </Link>
          <Transition
            show={isPriveOpen}
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <div className="absolute left-0 z-50 mt-2 w-64 bg-black/95 backdrop-blur-xl border border-[#57c0af]/30 rounded-2xl shadow-2xl overflow-hidden">
              <div className="p-2">
                {servicesData.map((product, index) => {
                  return (
                    <Link
                      key={index}
                      to={product.link || "/"}
                      className="flex items-center gap-3 p-2 rounded-xl hover:bg-white/5 transition-all duration-200 group/item"
                      onClick={(e) => handleScrollToSection(e, "/#nuqiprive")}
                    >
                      <div
                        className="w-8 h-8 rounded-lg flex items-center justify-center border border-white/10 group-hover/item:border-current transition-colors overflow-hidden"
                      >
                        <img src={product.mediaSrc} alt={product.title} className="w-full h-full object-cover" />
                      </div>
                      <span className="text-xs text-white group-hover/item:text-[#57c0af] transition-colors">
                        {product.title}
                      </span>
                    </Link>
                  );
                })}
              </div>
            </div>
          </Transition>
        </li>
                  <NavItem href="/iris" isActive={false} onClick={() => setActiveTab("/iris")}>
                    IRIS
                  </NavItem>
                  <NavItem
                    href="/ethosphere"
                    isActive={false}
                    onClick={() => setActiveTab("/ethosphere")}>
                    Ethosphere
                  </NavItem>
                  <NavItem
                    href="/Disclosures"
                    isActive={false}
                    onClick={() => setActiveTab("/Disclosures")}>
                    Disclosures
                  </NavItem>
                </ul>
              </nav>

              {/* Mobile Sign Up & Login Links */}
              <div className="mt-6">
                <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
                  <button className="w-full px-4 py-2 text-sm font-semibold text-black bg-[#57c0af] rounded-xl whitespace-nowrap hover:text-black">
                    Sign Up
                  </button>
                </a>

                <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
                  <button className="w-full mt-3 px-4 py-2 text-sm font-semibold text-white bg-transparent border border-[#57c0af] rounded-xl hover:bg-[#57c0af] hover:text-black">
                    Log In
                  </button>
                </a>
              </div>
            </Popover.Panel>
          </Transition.Child>
        </Transition.Root>
      </Popover>
    </div>
  );
}

function CountrySelect() {
  return (
    <div className="flex items-center justify-center">
      <Select
        onValueChange={(value) => {
          if (value === "india") {
            window.location.href = "https://in.nuqiwealth.com/";
          } else {
            window.location.href = "https://uae.nuqiwealth.com/";
          }
        }}
      >
        <SelectTrigger className="w-full bg-black text-white border border-[#57c0af] rounded-xl hover:bg-[#57c0af] hover:text-black transition-all duration-200">
          {/* Default globe icon */}
          {/* <Globe className="text-white" /> */}
          {/* <div className="flex items-center text-center">
            <img
              className="w-6 h-6 object-contain"
              src="/uae.jpg"
                alt="UAE"
            />
            </div> */}
          <div className="flex items-center text-center">
            <img
              className="w-6 h-6 object-contain"
              src="/india.jpg"
              alt="India"
            />
          </div>
        </SelectTrigger>
        <SelectContent className="bg-black text-white border border-[#57c0af] rounded-xl">
          <SelectItem value="india">
            <div className="flex items-center">
              <img
                className="w-6 h-6 object-contain mr-2"
                src="/india.jpg"
                alt="India"
              />
              India
            </div>
          </SelectItem>
          <SelectItem value="uae">
            <div className="flex items-center">
              <img
                className="w-6 h-6 object-contain mr-2"
                src="/uae.jpg"
                alt="UAE"
              />
              UAE
            </div>
          </SelectItem>


        </SelectContent>
      </Select>
    </div>
  );
}


// Home Logo Component
function HomeLogo() {
  
  const handleScrollToSection = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
    href: string
  ) => {
    event.preventDefault();

    const [path, hash] = href.split("#");
    if (path && window.location.pathname !== path) {
      window.location.href = `${path}#${hash}`;
    } else {
      const target = document.querySelector(`#${hash}`);
      target?.scrollIntoView({ behavior: "smooth" });
    }

    
  };

  return (
    <Link to="/" className="block">
      <img
        src="/white-in-logo-cropped.png"
        alt="Nuqi Logo"
        className="h-8 sm:h-10 md:h-8 w-auto lg:ml-20 object-contain"
         onClick={(e) => handleScrollToSection(e, "/#hero")}
      />
    </Link>
  );
}

// Main Navbar Component
export function Navbar() {
  // const { activeTab } = useActiveTab();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <header className="fixed top-0 w-full z-50 bg-black backdrop-blur-xl bg-opacity-50 border-opacity-50 border-b-[1px] border-[#4d4d4d] shadow-lg">
      <div className="container mx-auto px-4 py-2 flex items-center justify-between font-poppins">
        {/* Logo */}
        <div className="flex-shrink-0">
          <HomeLogo />
        </div>

        {/* Desktop Navigation (Visible only on desktop) */}
        <div className="hidden lg:flex flex-grow justify-center">
          <DesktopNavigation />
        </div>

        {/* Right Section */}
        <div className="flex items-center space-x-3 lg:space-x-4 lg:mr-5">
          {/* User Icon with Dropdown for Mobile */}
          <div className="lg:hidden relative">
            <Popover>
              <Popover.Button>
                <div className="flex items-center justify-center w-10 h-10 rounded-full bg-black border border-[#57c0af] text-white cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="white"
                    viewBox="0 0 24 24"
                    stroke="none"
                  >
                    <path d="M12 12c2.28 0 4-1.72 4-4s-1.72-4-4-4-4 1.72-4 4 1.72 4 4 4zm0 2c-3.31 0-10 1.67-10 5v1h20v-1c0-3.33-6.69-5-10-5z" />
                  </svg>
                </div>
              </Popover.Button>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Popover.Panel className="absolute z-10 justify-center items-center -mr-6  w-24 h-16 sm:-mt-3 bg-black border border-[#57c0af] rounded-2xl shadow-lg top-full right-0">
                  <div className="flex flex-col py-1">
                    {/* <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
                      <button className="flex items-center px-4 py-1 text-sm text-white hover:bg-[#57c0af] hover:text-black">
                        <span className="ml-2">Login</span>
                      </button>
                    </a> */}
                    <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
                      <button className="flex items-center px-4 py-1 text-sm text-white hover:bg-[#57c0af] hover:text-black">
                        <span className="ml-2">Log In</span>
                      </button>
                    </a>
                    <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
                      <button className="flex items-center px-4 py-1 text-sm text-white hover:bg-[#57c0af] hover:text-black">
                        <span className="ml-2">Sign Up</span>
                      </button>
                    </a>
                  </div>
                </Popover.Panel>
              </Transition>
            </Popover>
          </div>

          {/* Mobile Navigation (Hamburger Menu) */}
          <div className="lg:hidden order-3">
            <MobileNavigation />
          </div>
          <div className="lg:hidden">
            <CountrySelect />
          </div>

          {/* Sign Up & Login for Desktop */}
          <div className="hidden lg:flex space-x-4 order-2">
            {/* <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
              <button className="px-3 py-2 text-sm font-semibold text-black bg-[#57c0af] rounded-xl whitespace-nowrap hover:text-black">
                Sign Up
              </button>
            </a>*/}
            <a href="http://portal.nuqiwealth.in/" target="_blank" rel="noopener noreferrer">
              <button className="px-3 py-2 text-sm font-semibold text-white bg-transparent border border-[#57c0af] rounded-xl hover:bg-[#57c0af] hover:text-black">
                Log In/Sign Up
              </button>
            </a>

            <div className="flex lg:ml-4">
              <CountrySelect />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}


